<button (click)="goLiveToggle()">
  <span>{{ title }}</span>

  <svg width="10" height="10" viewBox="0 0 10 10" *ngIf="isLive">
    <defs>
      <path id="a" d="M2 9V1h2v8H2zm4 0V1h2.001v8H6z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="b" fill="#fff">
        <use xlink:href="#a" />
      </mask>
      <use fill="#757575" xlink:href="#a" />
      <g fill="#FFF" mask="url(#b)">
        <path d="M-7-6h21v21H-7z" />
      </g>
    </g>
  </svg>

  <svg width="10" height="10" viewBox="0 0 10 10" *ngIf="!isLive">
    <defs>
      <path id="a" d="M2 0v9.998L9.998 5z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="b" fill="#fff">
        <use xlink:href="#a" />
      </mask>
      <g fill="#EF5350" mask="url(#b)">
        <path d="M-7-6h21v21H-7z" />
      </g>
    </g>
  </svg>
</button>
